import $ from 'jquery';
import Router from 'root/router';
import Cache from 'root/cache';
import Modals from 'root/modals';
import Util from 'root/module/util';
import View from 'view/base';

export default View.extend({
    tagName: 'tr',

    events: {
        'click'              : 'onOpen',
        'click .survey-user' : 'onViewUser',
    },

    dom_handlers: {
        onOpen: function(e) {
            if ($(e.target).is('.select input, .select label') || $(e.target).hasClass('stop-propagation') || $(e.target).parents('.stop-propagation').length) {
                return;
            }

            Router.addQueryString('id', this.model.id, {trigger: false});
            Modals.openSurveyResponse(this.model, this.user_data, Cache.survey_response.models);
        },

        onViewUser: function(e) {
            e.preventDefault();

            if (typeof this.user_data[this.model.get('user_identification')] === 'undefined') {
                return;
            }

            Modals.openUserIdentification(this.model.get('user_identification'));
        }
    },

    event_handlers: {
        onUserDelete: function(model) {
            if (model.get('identification')=== this.model.get('user_identification')) {
                this.model.set('user_identification', '');
            }
        }
    },

    initialize: function(options) {
        this.questions = options.questions;
        this.user_data = options.user_data;

        this.listenTo(this.model, 'change', this.render);
        this.listenTo(Cache.user_identification, 'remove', this.event_handlers.onUserDelete.bind(this));
    },

    render: function() {
        var user_data = this.user_data[this.model.get('user_identification')] || {};

        if (this.model.get('user_identification') === '123456' && user_data.display_name === 'someone' && user_data.email === 'someone@example.com') {
            user_data.display_name = 'Example User';
        }

        var content =
        '<td class="select">' +
            '<input type="checkbox" id="re_' + this.model.id + '" data-val="' + this.model.id + '">' +
            '<label for="re_' + this.model.id + '"></label>' +
        '</td>' +
        '<td>' + this.model.id + '</td>' +
        '<td>' +
            '<div>' + Util.moment(this.model.get('create_time'), 'DD MMM YYYY', false, false) + '</div>' +
            '<div class="text-info text-small">' + Util.moment(this.model.get('create_time'), 'h:mm a', false, false) + '</div>' +
        '</td>' +
        '<td>' +
            (this.model.get('user_identification') ?
            '<a href="#" class="survey-user stop-propagation">' +
            (user_data.display_name || user_data.email || '<span class="badge-id">' + this.model.escape('user_identification') + '</span>') +
            '<i class="fa-solid fa-square-arrow-up-right text-icon"></i>' +
            '</a>' :
            '<span class="text-info">-</span>') +
        '</td>';

        this.questions.forEach((question) => {
            content +=
            '<td class="question"><div>' + (this.model.renderAnswer(question) || '-') + '</div></td>';
        });

        content +=
        '<td><div>' + (this.model.escape('location') || '-') + '</div></td>';

        this.$el.html(content);

        return this;
    }
});